export default __webpack_public_path__ + "img/cvmGbOHe.6e6af528.svg";